const reasons = [
  {
    icon: "ri-tools-line",
    title: "Profesyonel ekipman kullanımı",
    desc: "Her hizmet türüne uygun modern ekipman ve malzeme ile çalışıyoruz.",
  },
  {
    icon: "ri-team-line",
    title: "Deneyimli ve düzenli çalışma ekibi",
    desc: "Alanlarında uzman, eğitimli ve disiplinli bir ekiple hizmet veriyoruz.",
  },
  {
    icon: "ri-time-line",
    title: "Randevuya uygun zamanında hizmet",
    desc: "Belirlenen saatte yerinde olur, zamanınıza saygı duyarız.",
  },
  {
    icon: "ri-home-gear-line",
    title: "Daire, apartman, site ve iş yerlerine özel çözümler",
    desc: "Her mekanın yapısına ve kullanım yoğunluğuna göre planlama yaparız.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Hijyen odaklı detaylı temizlik anlayışı",
    desc: "Yüzeysel temizlik değil, detaylı ve hijyen odaklı bir süreç uyguluyoruz.",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "Müşteri memnuniyetine önem veren süreç yönetimi",
    desc: "Her adımda sizden geri bildirim alır, memnuniyetinizi öncelik tutarız.",
  },
  {
    icon: "ri-map-pin-line",
    title: "Sarıçam ve Adana geneline hızlı hizmet",
    desc: "Ana hizmet bölgemiz Sarıçam olmak üzere Çukurova, Seyhan, Yüreğir ve Adana geneline ulaşıyoruz.",
  },
];

export default function WhyChooseSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1.5 rounded-full mb-3">
            Neden Day Temizlik?
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Temizlikte detay, hizmette güven
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Day Temizlik Adana olarak yalnızca yüzeysel temizlik değil, yaşam alanlarınızı daha hijyenik, düzenli ve kullanıma hazır hale getiren detaylı çözümler sunuyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {reasons.map((reason, index) => (
            <div
              key={reason.title}
              className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/50 hover:border-accent-300/60 transition-colors"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-accent-100/80 rounded-lg mb-3">
                <i className={`${reason.icon} w-5 h-5 flex items-center justify-center text-accent-500`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1.5">
                {reason.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {reason.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}